import { AccessGrantNotification as AccessGrantNotificationType } from '../types'
import { AccessGrantAssetType } from 'types'
import { BaseNotificationItem } from '../BaseNotificationItem'
import Styles from '../NotificationItem.module.scss'
import { Lock, Unlocked } from 'almanac-ui/icons'
import { articleOrLayerPath } from '../utils'

interface Props {
  notification: AccessGrantNotificationType
  onClose: () => void
}

export const AccessGrantNotification = ({ notification, onClose }: Props) => {
  const subject = notification.subject
  const path = notification.folder ? notification.folder.url : articleOrLayerPath({ notification })
  let assetType: string

  if (notification.folder) {
    assetType = 'folder'
  } else if (subject.asset_type === AccessGrantAssetType.Layer) {
    assetType = 'layer'
  } else {
    assetType = 'doc'
  }

  return (
    <BaseNotificationItem
      notification={notification}
      onClose={onClose}
      title={`granted you ${subject.access} access to a ${assetType}`}
      icon={
        <div role="img" title="Access Icon" className={Styles.icon}>
          <Lock />
        </div>
      }
      path={path}
      aria-label="Access Grant Notification"
      secondaryAction={
        <div className={Styles.accessGrantLabel}>
          <Unlocked /> Granted!
        </div>
      }
    />
  )
}
